import { lazy } from 'react';

export type RouteModule = Record<string, unknown>;

export const isComponentType = (
  value: unknown,
): value is React.ComponentType => {
  return (
    typeof value === 'function' || (typeof value === 'object' && value !== null)
  );
};

export const lazyNamedExport = <TModule extends RouteModule>(
  loader: () => Promise<TModule>,
  exportName: keyof TModule,
) =>
  lazy(async () => {
    const moduleValue = await loader();
    const component = moduleValue[exportName];

    if (!isComponentType(component)) {
      throw new Error(`Export ${String(exportName)} is not a React component`);
    }

    return { default: component };
  });
